import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function travelModeFilterSelected({
    previousState,
    searchParams = {},
    selected,
    state,
    totalTrips,
    type,
}) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    const property = {
        num_trips: totalTrips,
        selected,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_search',
        label: `travel_mode_${type}`,
        property,
    });

    amplitude.track('Search Filtered', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        depart_address: originText,
        depart_place_id: originPlaceId,
        filter_type: 'travel_mode',
        mode_type: type,
        results_count_before: totalTrips,
        ui_source: 'sidebar_filter',
        updated_from: previousState,
        updated_to: state,
    });
}

export default {
    travelModeFilterSelected,
};
